import React from 'react'

const Footer = () => {
  return (
    <div className='footer'>
        <p>MADE BY RAHUL BAGHEL </p>
    </div>
  )
}

export default Footer
